import styled from "styled-components";
import { getStyle, getThemeColor, H00 } from "constants/colors";
// import { MediaScreenMobile } from 'components/common/styled'

/**
 * 前置：用于表达输入框标签。默认状态为
 */
export const AddonBefore = styled.label`
  position: absolute;
  font-size: 12px;
  line-height: 16px;
  transition: all 0.1s linear;
  color: ${getThemeColor("input_addon")};
  .icon-search {
    font-size: 16px !important;
    color: ${getThemeColor("input_text")} !important;
  }
  .inputBorder {
    border-bottom: 1px dotted ${getThemeColor("input_addon")};
  }
`;

/**
 * 整体容器
 */
export const Wrapper = styled.div<{ noBorder?: boolean }>`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  height: 54px; // 固定高度
  padding: 9px 10px; // 基本边框
  /* background: ${getThemeColor("special_input_bg")}; */
  border-radius: 6px;
  ${(props) =>
    !props.noBorder ? "border: 1px solid var(--color-input-border) " : ""};
  /* ${(props) => (!props.noBorder ? "background: var(--dialog-sk)" : "")}; */
  transition: all 0.2s ease-in-out;

  &.focusing {
    border-color: var(--color-primary);

    @media screen and (max-width: 768px) {
      ${AddonBefore} {
        color: var(--color-primary);
      }
    }
  }

  &.disabled {
    background: var(--color-placeholder-text);
    cursor: not-allowed;
  }

  &.slim {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const AddonAfter = styled.div`
  white-space: nowrap;
  font-size: 12px;
  color: ${getStyle(H00)};
  line-height: 16px;
  transition: all 0.1s linear;
`;

export const DisabledTip = styled.div`
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  flex: 1;
  padding-inline-end: 10px;
  user-select: none;
  white-space: inherit;
  color: ${getThemeColor("plain_select_text")};
`;

/**
 * 主容器：负责包含label、input、unit等
 */
export const MainContainer = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${AddonBefore} {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  ${AddonAfter} {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  input {
    background: transparent;
    border: none;
    outline: none;
    width: 100%;
    flex: 1;
    padding-block: 0;
    padding-inline: 0 10px;
    flex-basis: auto; // 兼容firefox
    -webkit-appearance: none;
    color: ${getThemeColor("input_text")};
    font-size: 16px;
    line-height: 16px;
  }

  &.disabled {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    ${AddonAfter} {
      top: 0;
      right: 0;
      transform: unset;
      position: relative;
      color: var(--text_white_5);
    }
  }

  &.focusing {
    align-items: flex-end;

    ${AddonBefore} {
      top: 0;
      left: 0;
      transform: unset;
    }

    ${AddonAfter} {
      bottom: 0;
      right: 0;
      transform: unset;
    }
  }

  &.slim {
    ${AddonBefore}, ${AddonAfter} {
      position: relative;
      top: unset;
      left: unset;
      transform: translateY(0);
      line-height: 12px;

      .iconfont {
        font-size: 12px;
      }
    }

    input {
      padding: 0 10px;
      font-size: 12px;
      line-height: 12px;
    }
  }

  &.slim.focusing {
    align-items: center;
  }
`;
export const CompanyButton = styled.button`
  background: ${getThemeColor("card_header_bg_disabled")};
  border-radius: 6px;
  font-size: 12px;
  color: ${getThemeColor("input_text")};
  line-height: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  height: 100%;
  padding: 0 5px;

  &.active {
    background: var(--color-primary);
    color: var(--color-white-text);
  }
`;

/**
 * 额外容器：用于放置按钮
 */
export const ExtraContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline-start: 10px;
  font-size: 12px;
  color: ${getThemeColor("input_addon")};
  line-height: 16px;

  &.disabled {
    color: ${getStyle(H00)};
  }
`;

/**
 * 主容器：负责包含label、input、unit等
 */
export const StrategyMainContainer = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  ${AddonBefore} {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 1;
    color: var(--color-input-border);
  }

  ${AddonAfter} {
    line-height: 20px;
    font-size: 12px;
    font-weight: 400;
  }

  input {
    background: transparent;
    border: none;
    outline: none;
    width: 100%;
    flex: 1;
    padding-block: 0;
    padding-inline: 0 6px;
    flex-basis: auto; // 兼容firefox
    -webkit-appearance: none;
    color: ${getThemeColor("input_text")};
    font-size: 12px;
    line-height: 16px;
    z-index: 3;
    position: relative;
  }

  // &.disabled {
  //     display: flex;
  //     align-items: center;
  //     justify-content: flex-start;

  //     ${AddonAfter} {
  //         top: 0;
  //         right: 0;
  //         transform: unset;
  //         position: relative;
  //         color: var(--text_white_5);
  //     }
  // }

  &.focusing {
  }

  // &.slim {
  //     ${AddonBefore}, ${AddonAfter} {
  //         position: relative;
  //         top: unset;
  //         left: unset;
  //         transform: translateY(0);
  //         line-height: 12px;

  //         .iconfont {
  //             font-size: 12px;
  //         }
  //     }

  //     input {
  //         padding: 0 10px;
  //         font-size: 12px;
  //         line-height: 12px;
  //     }
  // }

  // &.slim.focusing {
  //     align-items: center;
  // }
`;
